if (!customElements.get("sticky-product-cta")) {
  customElements.define(
    "sticky-product-cta",
    class StickyProductCTA extends HTMLElement {
      connectedCallback() {
        this.sectionId = this.dataset.sectionId;
        this.formId = this.dataset.productFormId;

        this.productInfo = document.getElementById(
          `MainProduct-${this.sectionId}`,
        );

        this.productForm = document.getElementById(this.formId);

        this.originalSubmitButton = document.getElementById(
          `ProductSubmitButton-${this.sectionId}`,
        );

        this.mediaTarget = this.productInfo?.querySelector(
          ".product__media-wrapper",
        );

        this.priceSource = document.getElementById(`price-${this.sectionId}`);

        this.priceTarget = this.querySelector("[data-sticky-price]");
        this.buyNowButton = this.querySelector("[data-sticky-buy-now]");
        this.buttonText = this.querySelector("[data-sticky-button-text]");
        this.statusElement = this.querySelector("[data-sticky-status]");
        this.spinner = this.querySelector(".loading__spinner");

        if (
          !this.productInfo ||
          !this.productForm ||
          !this.originalSubmitButton ||
          !this.mediaTarget ||
          !this.buyNowButton
        ) {
          return;
        }

        this.isLoading = false;

        this.handleAddToCart = this.handleAddToCart.bind(this);
        this.handleResize = this.handleResize.bind(this);

        this.buyNowButton.addEventListener("click", this.handleAddToCart);

        this.createMediaObserver();
        this.createContentObserver();

        window.addEventListener("resize", this.handleResize);

        this.syncPrice();
        this.syncButtonState();
      }

      disconnectedCallback() {
        this.buyNowButton?.removeEventListener("click", this.handleAddToCart);

        window.removeEventListener("resize", this.handleResize);

        this.mediaObserver?.disconnect();
        this.contentObserver?.disconnect();

        document.documentElement.classList.remove("sticky-product-cta-visible");
      }

      createMediaObserver() {
        this.mediaObserver = new IntersectionObserver(
          ([entry]) => {
            /*
             * Show only after the product-media area has moved
             * completely above the viewport.
             */
            const hasPassedMedia =
              !entry.isIntersecting && entry.boundingClientRect.bottom <= 0;

            this.setVisibility(hasPassedMedia);
          },
          {
            threshold: 0,
          },
        );

        this.mediaObserver.observe(this.mediaTarget);
      }

      createContentObserver() {
        this.contentObserver = new MutationObserver(() => {
          this.syncPrice();
          this.syncButtonState();
        });

        if (this.priceSource) {
          this.contentObserver.observe(this.priceSource, {
            childList: true,
            subtree: true,
            characterData: true,
          });
        }

        this.contentObserver.observe(this.originalSubmitButton, {
          attributes: true,
          childList: true,
          subtree: true,
          characterData: true,
        });
      }

      handleResize() {
        if (!window.matchMedia("(max-width: 749px)").matches) {
          this.setVisibility(false);
        }
      }

      setVisibility(shouldShow) {
        const isMobile = window.matchMedia("(max-width: 749px)").matches;

        const isVisible = isMobile && shouldShow;

        this.classList.toggle("is-visible", isVisible);
        this.setAttribute("aria-hidden", String(!isVisible));

        document.documentElement.classList.toggle(
          "sticky-product-cta-visible",
          isVisible,
        );
      }

      syncPrice() {
        if (!this.priceSource || !this.priceTarget) return;

        this.priceTarget.innerHTML = this.priceSource.innerHTML;
      }

      syncButtonState() {
        if (!this.originalSubmitButton || !this.buyNowButton) return;

        const isDisabled =
          this.originalSubmitButton.disabled ||
          this.originalSubmitButton.getAttribute("aria-disabled") === "true";

        const isLoading =
          this.originalSubmitButton.classList.contains("loading");

        const originalText =
          this.originalSubmitButton
            .querySelector("span")
            ?.textContent?.trim() || "";

        this.buyNowButton.disabled = isDisabled || isLoading;
        this.buyNowButton.classList.toggle("loading", isLoading);

        this.spinner?.classList.toggle("hidden", !isLoading);

        if (isLoading) {
          this.buttonText.textContent = "Adding...";
        } else if (isDisabled) {
          this.buttonText.textContent = originalText || "Unavailable";
        } else {
          this.buttonText.textContent =
            window.variantStrings?.addToCart || "Add to cart";
        }
      }

      handleAddToCart() {
        if (!this.originalSubmitButton || this.buyNowButton.disabled) {
          return;
        }

        /*
         * Trigger the original product Add to Cart button.
         * The existing product-form.js handles:
         * - selected variant
         * - selected quantity
         * - cart drawer/notification
         * - loading state
         * - sold-out errors
         */
        this.originalSubmitButton.click();
      }

      setLoading(isLoading) {
        this.isLoading = isLoading;
        this.buyNowButton.disabled = isLoading;

        this.buyNowButton.classList.toggle("loading", isLoading);
        this.spinner?.classList.toggle("hidden", !isLoading);

        this.buttonText.textContent = isLoading ? "Processing..." : "Buy Now";
      }

      showError(message) {
        if (!this.statusElement) return;

        this.statusElement.textContent = message;
      }
    },
  );
}
